<template>
  <v-list-item-title class="d-flex align-center">
    <div>{{ menuItem.displayText() }}</div>
    <v-spacer />
    <v-chip
      v-if="erroredIntegrationsCount > 0"
      class="chip ml-1 white--text"
      color="errorChip"
      small
      data-qa="integration_error_count"
      >{{ erroredIntegrationsCount }}</v-chip
    >
  </v-list-item-title>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { MenuItem } from "@/app/ui/navigation/types";
import integrationErrorStore from "@/store/modules/integrationErrorStore";

interface IntegrationsMenuItemProps {
  menuItem: MenuItem;
}

defineProps<IntegrationsMenuItemProps>();

const erroredIntegrationsCount = computed(
  () => integrationErrorStore.state.erroredIntegrationsCount
);
</script>

<style lang="sass" scoped>
.chip
  font-size: 14px
  font-weight: 700
  height: auto!important
  padding: 0 8px
</style>
